import React from 'react';
import cc from 'classcat';

import { Address, Map } from '../../index';

import styles from './styles.module.scss';

interface Props {
  title: string;
  address: Maybe<AddressFragment> | null | undefined;
  amenities: Maybe<AmenitiesFragment>[] | null | undefined;
  headingTextPrimary?: string | null;
  headingTextSecondary?: string | null;
}

const Amenities = ({ title, address, amenities, headingTextPrimary, headingTextSecondary }: Props) => (
  <div className={cc(['section', styles.amenitiesSection])}>
    <div className="container">
      {(headingTextPrimary || headingTextSecondary) && (
        <div className={styles.amenitiesIntro}>
          <p className={styles.preheading}>
            {amenities && amenities?.length ? 'LOCATION & AMENITIES' : 'LOCATION'}
          </p>
          {headingTextPrimary && (
            <h2>{headingTextPrimary}</h2>
          )}
          {headingTextSecondary && (
            <p className={styles.subheading}>{headingTextSecondary}</p>
          )}
        </div>
      )}

      <div id="location" className={styles.amenitiesGrid}>
        <div className={styles.contentColumn}>
          {!(headingTextPrimary || headingTextSecondary) && (
            <>
              <div className={styles.sectionLabel}>
                {amenities && amenities?.length ? 'LOCATION & AMENITIES' : 'LOCATION'}
              </div>
              <h2 className={styles.heading}>{title} is located:</h2>
            </>
          )}
          {(headingTextPrimary || headingTextSecondary) && (
              <p className={styles.addressIntro}>
                  Location
              </p>
          )}
          {address! && <Address address={address} />}
          {amenities && amenities?.length > 0 && (
            <div className={styles.amenitiesList}>
              {amenities.map((amenity) => {
                if (!amenity) return null;

                const amenityTitle = amenity?.amenity?.[0]?.title;
                const iconUrl = amenity?.amenity?.[0]?.icon?.[0]?.url;
                const distance = amenity?.distance;

                return (
                  <div key={amenity.uid || amenityTitle} className={styles.amenityItem}>
                    {iconUrl && (
                      <div className={styles.amenityIcon}>
                        <img src={iconUrl} alt={amenityTitle || ''} />
                      </div>
                    )}
                    {amenityTitle && (
                      <h3 className={styles.amenityTitle}>{amenityTitle}</h3>
                    )}
                    {distance && (
                      <p className={styles.amenityDistance}>{distance} km</p>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>
        <div className={styles.mapColumn}>
          <div className={styles.map}>
            <Map
              address={`${title}, ${address?.address}`}
              lat={address?.lat}
              lng={address?.lng}
              width={720}
              height={740}
              alt={`Map of ${title}`}
            />
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default Amenities;
